// extracted by mini-css-extract-plugin
export default {"contactContainer":"mRSIl","contact":"SijlW","icon":"SxyXU","link":"KfO6i"};